<template>
  <div id="fh5co-header">
    <header id="fh5co-header-section">
      <div class="header-container">
        <div class="nav-header">
          <a href="#" class="js-fh5co-nav-toggle fh5co-nav-toggle" @click="naviOpen" :class="{'is-active': active}"><i></i></a>
          <h1 id="fh5co-logo"><a href="/" title="Legame online">君の脂肪を燃やし隊<span> - I want to burn your fat -</span></a></h1>
          <nav class="navi pc-navi">
            <ul class="sf-menu" id="fh5co-primary-menu">
              <li><a href="/" title="TOP">TOP</a></li>
              <li><a href="/corporation" title="法人向けサービス">法人向けサービス</a></li>
            </ul>
          </nav>
          <transition name="navi">
            <nav id="fh5co-menu-wrap" role="navigation" class="navi" v-show="navi">
              <ul class="sf-menu" id="fh5co-primary-menu">
                <li><a href="/" title="TOP">TOP</a></li>
                <li><a href="/corporation" title="法人向けサービス">法人向けサービス</a></li>
              </ul>
            </nav>
          </transition>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      active: false,
      navi: false
    }
  },
  methods: {
    naviOpen: function() {
      this.active = !this.active
      this.navi = !this.navi
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.header-container{
  padding-left: 20px;
  padding-right: 10px;
}

.sf-menu{
  margin: 0;
}

#fh5co-header {
  position: relative;
  height: 85px;
  background-color: #333;
  margin-bottom: 0;
  z-index: 9999999;
}

#fh5co-header-section {
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}

.nav-header {
  margin-top: 18px;
  position: relative;
  float: left;
  width: 100%;
}

#fh5co-logo {
  z-index: 2;
  font-size: 28px;
  font-weight: 900;
  float: left;
  margin-bottom: 0;
  margin-top: 5px;
}
#fh5co-logo a {
  position: relative;
}
#fh5co-logo a:after {
  position: absolute;
  content: "";
  top: -5px;
  left: -9px;
  background: #cdff19;
  width: 10px;
  height: 10px;
}
#fh5co-logo span {
  padding: 0;
  margin: 0;
  font-weight: 100;
  font-size: 20px;
}
@media screen and (max-width: 768px) {
  #fh5co-header {
    height: 70px;
  }
  #fh5co-logo {
    width: 100%;
    font-size: 20px;
    float: none;
    text-align: center;
    margin-top: 5px;
  }
  #fh5co-logo span {
    display: none;
  }
  #fh5co-primary-menu {
    background-color: rgba(0, 0, 0, 0.7);
  }
  .sf-menu > li {
    float: none;
  }
  .pc-navi{
    display: none;
  }
}

#fh5co-logo a {
  color: #fff;
}
#fh5co-logo a:hover,
#fh5co-logo a:focus {
  color: #fff !important;
}

#fh5co-menu-wrap {
  position: relative;
  z-index: 2;
  display: block;
  float: right;
}

#fh5co-primary-menu > li > ul li.active > a {
  color: #cdff19 !important;
}
#fh5co-primary-menu > li > .sf-with-ul:after {
  border: none !important;
  font-family: "icomoon";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  float: right;
  margin-right: -5px;
  top: 50%;
  margin-top: -7px;
  content: "\e922";
  color: rgba(255, 255, 255, 0.5);
}
#fh5co-primary-menu > li > ul li {
  position: relative;
}
#fh5co-primary-menu > li > ul li > .sf-with-ul:after {
  border: none !important;
  font-family: "icomoon";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  float: right;
  margin-right: 10px;
  top: 20px;
  font-size: 16px;
  content: "\e924";
  color: rgba(0, 0, 0, 0.5);
}

#fh5co-primary-menu .fh5co-sub-menu {
  padding: 10px 7px 10px;
  background: #fff;
  left: 0;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  -ms-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  -o-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}
#fh5co-primary-menu .fh5co-sub-menu > li > .fh5co-sub-menu {
  left: 100%;
}

#fh5co-primary-menu .fh5co-sub-menu:before {
  position: absolute;
  top: -9px;
  left: 20px;
  width: 0;
  height: 0;
  content: "";
}

#fh5co-primary-menu .fh5co-sub-menu:after {
  position: absolute;
  top: -8px;
  left: 30px;
  width: 0;
  height: 0;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #fff;
  border-left: 8px solid transparent;
  content: "";
}

#fh5co-primary-menu .fh5co-sub-menu .fh5co-sub-menu:before {
  top: 6px;
  left: 100%;
}

#fh5co-primary-menu .fh5co-sub-menu .fh5co-sub-menu:after {
  top: 7px;
  right: 100%;
  border: none !important;
}

.site-header.has-image #primary-menu .sub-menu {
  border-color: #ebebeb;
  -webkit-box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.09);
  -moz-box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.09);
  -ms-box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.09);
  -o-box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.09);
  box-shadow: 0 5px 15px 4px rgba(0, 0, 0, 0.09);
}
.site-header.has-image #primary-menu .sub-menu:before {
  display: none;
}

#fh5co-primary-menu .fh5co-sub-menu a {
  letter-spacing: 0;
  padding: 0 15px;
  font-size: 18px;
  line-height: 34px;
  color: #fff;
  text-transform: none;
  background: none;
}
#fh5co-primary-menu .fh5co-sub-menu a:hover {
  color: #cdff19 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue